<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <b-form-group label="Category" label-class="product-creation-section-labels py-0"></b-form-group>
      </b-col>
      <b-col lg="5">
        <b-form-group
          :state="!formValidatedState('category_id')"
          :invalid-feedback="apiErrors.category_id">
        <ProductCategoryDropdown
          :selectedCategory="category_id"
          :isDisabled="editingFromLocationsPage"
          @setSelectedCategory="setSelectedCategory"
          :origin="origin" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";
import ProductCategoryDropdown from "@/components/products/ProductCategoryDropdown";
import { productsMixins } from "@/mixins/products_mixins";

export default {
  props: ["origin"],
  components: { ProductCategoryDropdown },
  computed: {
    ...mapFields("products", ["category_id"]),
    ...mapState("products", ["errors"]),
    editingFromLocationsPage: {
      get() {
        return this.origin === "edit_product";
      },
      set(status) {
        return status;
      }
    }
  },
  mixins: [productsMixins],
  created() {
    this.$store.dispatch("estoreInventories/getCategories");
  },
  methods: {
    setSelectedCategory(id) {
      this.category_id = id;
    }
  }
}
</script>
